"use client";

import React, { useState, useId } from "react";
import {
  Button,
  Form,
  FormControl,
} from "react-bootstrap";
import { Formik } from "formik";
import useApi from "@/components/api/useApi";
import { useRouter } from "next/navigation";

import "@/components/login/LoginPage.css";
import UralitySquareImage from "@/components/shared/UralitySquareImage";

let yup = require("yup");

const LoginForm = ({
  inline = false,
  className = null,
  location = null,
  stateParam,
  community = null,
  logoId = null
}) => {
  const router = useRouter();
  const api = useApi();
  const randomNumber = useId();

  const [error, setError] = useState(null);

  const onSuccess = (url) => {
    router.push(url);
  };

  const redirectToForgotPassword = () => {
    console.log("redirecting to forgot password", location);
    router.push(`/forgot${location ? `?state=${location}` : ""}`);
  };

  const attemptLogin = (values, setSubmitting) => {
    setSubmitting(true);

    api.getJwtToken(values.email, values.password, community, result => {
      if (result.success) {
        // console.log(result, result.success, result.payload, result.defaultUrl);
        var redirectUrl = generateRedirectUrl(
          result.payload,
          result.defaultUrl
        );
        // console.log(redirectUrl);
        onSuccess(redirectUrl);
      } else {
        setError("Invalid email address or password.");
        setSubmitting(false);
      }
    });
  };

  const generateRedirectUrl = (payload, defaultUrl) => {
    var defaultPath = `${defaultUrl}`;

    // const search = location ? location.search : null;

    if (stateParam) {
      defaultPath = stateParam;
    }
    // } else if (search) {
    //   const values = queryString.parse(search);
    //   if (values && values.state) {
    //     defaultPath = values.state;
    //   }
    // } else if (location.state) {
    //   defaultPath = location.state.from.pathname;
    // }
    return defaultPath;
  };

  const schema = yup.object({
    email: yup
      .string()
      .required()
      .email()
      .label("Email Address"),
    password: yup
      .string()
      .required()
      .label("Password")
  });

  const values = {
    email: "",
    password: ""
  };

  return (
    <Formik
      initialValues={values}
      enableReinitialize={true}
      validateOnChange={true}
      validationSchema={schema}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          attemptLogin(values, setSubmitting);
        }, 400);
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        isSubmitting,
        isValid,
        values,
        touched,
        errors,
        setFieldValue
      }) => (
        <Form
          className={className}
          id={`login-form-${randomNumber}`}
          onSubmit={handleSubmit}
        >
          {!inline && (
            <div className="center-child-div-parent">
              <div
                className="center-child-div-child"
                style={{ margin: "1rem" }}
              >
                {logoId ? (
                  <UralitySquareImage imageId={logoId} size="lg" />
                ) : (
                  <div
                    className="logo-stacked"
                  />
                )}
              </div>
            </div>
          )}
          {error && !isSubmitting && <p className="error">{error}</p>}

          <div className="form-group" id="email">
            <Form.Label style={{ float: "left" }}>Email Address</Form.Label>
            <FormControl
              autoFocus
              type="email"
              name="email"
              value={values.email}
              onChange={handleChange}
              placeholder="Email Address"
            />
          </div>
          <div className="form-group" id="password">
            <Form.Label style={{ float: "left" }}>Password</Form.Label>
            <FormControl
              name="password"
              value={values.password}
              onChange={handleChange}
              type="password"
              placeholder="Password"
            />
          </div>
          <br />
          <div className="center-child-div-parent">
            <div className="center-child-div-child" style={{ width: 240 }}>
              <button
                className="btn btn-primary"
                form={`login-form-${randomNumber}`}
                disabled={!isValid || isSubmitting}
                type="submit"
              >
                Log In
              </button>
            </div>
          </div>
          {!inline && (
            <>
              <br />
              <button className="a" type="button" onClick={() => redirectToForgotPassword()}>
                I forgot my password
              </button>
            </>
          )}
        </Form>
      )}
    </Formik>
  );
};

export default LoginForm;
